const UpsCardContainer = ({ title, children }: { title: string, children: React.ReactNode }) => {
  return (
    <div className="flex flex-col gap-0.5">
      <div className="bg-dark w-full rounded-md">
        <h3 className="text-2xl font-bold text-center py-1">{title}</h3>
      </div>
      <div className="flex-1 bg-dark rounded-md">
        {children}
      </div>
    </div>
  );
};

export default UpsCardContainer;